import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<any>();
export const CauseListColumn = [
  columnHelper.accessor((row, index) => index + 1, {
    header: "#",
    cell(props) {
      return <span>{props.getValue()}</span>;
    },
  }),
  columnHelper.accessor("date", {
    header: "Date",
  }),

  columnHelper.accessor("appeal_no", {
    header: "Appeal Number",
  }),
  columnHelper.accessor("parties", {
    header: "Parties",
  }),
  columnHelper.accessor("nature", {
    header: "Nature",
  }),
  columnHelper.accessor("business_of_the_day", {
    header: "Business of the day",
  }),
];
